import React from 'react';
import DataMatchingWhatImage from 'assets/data_matching_what.svg';
import DataMatchingWhyImage from 'assets/data_matching_why.svg';
import { Button, Col, Row } from 'antd';
import { Carousel } from 'syngenta-digital-cropwise-react-ui-kit';
import { useTranslation } from 'react-i18next';

const DataMatchingPopoverContent = () => {
  const { t } = useTranslation();
  const nextBtn = () => {
    return (
      <Button size="small" type="text" data-testid="DataMatchingPopoverNextBtn">
        Next
      </Button>
    );
  };
  const backBtn = () => {
    return (
      <Button size="middle" type="text" data-testid="DataMatchingPopoverPrevBtn">
        Back
      </Button>
    );
  };
  return (
    <div
      className="max-w-280px"
      data-testid="DataMatchingPopoverContentCarousel"
      data-cy="DataMatchingPopoverContentCarousel"
    >
      <Carousel arrows prevArrow={backBtn()} nextArrow={nextBtn()} draggable={true}>
        <Row justify="center">
          <Col>
            <img
              className="data-matching-what-image"
              src={DataMatchingWhatImage}
              alt={'Why data matching img'}
              data-testid="DataMatchingWhatImageId"
            />
          </Col>
          <Col>
            <br />
          </Col>
          <Col>
            <br />
          </Col>
          <Col>
            {t(
              'Data Matching matches items updated from integrations with the corresponding options in the Cropwise catalog. This way, your data is always clear and organized.',
            )}
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <img
              className="data-matching-why-image"
              src={DataMatchingWhyImage}
              alt={'Why data matching why img'}
              data-testid="DataMatchingWhyImageId"
            />
          </Col>
          <Col>
            <br />
          </Col>
          <Col>
            <br />
          </Col>
          <Col>
            {t(
              "Automatic matching isn't always possible, but don't worry-once you manually match an item, you can save it for all future updates.",
            )}
          </Col>
        </Row>
      </Carousel>
    </div>
  );
};

export default DataMatchingPopoverContent;
